

import React from 'react';
import './TrendGraph.scss';
import { Line } from "react-chartjs-2";
import moment from 'moment';

function TrendGraph(props) {
    return (
        <div className="trend-graph-container">

            {props.selectedParamList && props.selectedParamList.length > 0 && props.selectedParamList.map((graphParam) => {
                // Generate X-axis data (timestamps)
                if (graphParam.label == "NIBP") {

                    const xgraphData = props.data.data.map((ele) => {
                        return ele["time"] && moment(ele["time"]).subtract(330, "minutes").locale('en').format("HH:mm");
                    });

                    const filteredData = props.data.data.reduce((acc, current) => {
                        const found = acc.find(item => item.time === current.time);
                        if (!found) {
                            acc.push(current);
                        }
                        return acc;
                    }, []);

                    const y1graphData = filteredData.map((ele) => ele['bpSystolic']);
                    const y2graphData = filteredData.map((ele) => ele['bpDiastolic']);
                    const y3graphData = filteredData.map((ele) => ele['bpMean']);


                    console.log(y1graphData)
                    console.log(y2graphData)
                    console.log(y3graphData)

                    return (
                        <Line
                            className="line-graph-vital"
                            key={graphParam.name}
                            data={{
                                labels: xgraphData,
                                datasets: [
                                    {
                                        label: 'NibpSystolic', // Descriptive label for the red line
                                        data: y1graphData,
                                        fill: false,
                                        borderColor: 'white',
                                        borderWidth: 2,
                                        tension: 0,
                                        pointRadius: 1.5,
                                    },
                                    {
                                        label: 'NibpDiastolic', // Descriptive label for the blue line
                                        data: y2graphData,
                                        fill: false,
                                        borderColor: 'white',
                                        borderWidth: 2,
                                        tension: 0,
                                        pointRadius: 1.5,
                                    },
                                    {
                                        label: 'NibpMean', // Descriptive label for the green line
                                        data: y3graphData,
                                        fill: false,
                                        borderColor: 'white',
                                        borderWidth: 2,
                                        tension: 0,
                                        pointRadius: 1.5,
                                    }
                                ],
                            }}
                            options={{
                                plugins: {
                                    tooltip: {
                                        enabled: true,
                                        position: 'nearest',
                                    },
                                    legend: {
                                        display: true, // Enable legend
                                        labels: {
                                            usePointStyle: true, // Uses point style for the labels (optional)
                                        }
                                    },
                                    title: {
                                        display: true,
                                        text: graphParam.label,
                                        align: 'start',
                                        color: 'white',
                                        font: {
                                            size: 16,
                                            weight: 600,
                                        },
                                        padding: {
                                            bottom: 20,
                                        }
                                    },
                                },
                                scales: {
                                    x: {
                                        grid: {
                                            borderColor: '#4D4D4D'
                                        },
                                        ticks: {
                                            autoSkip: true,
                                            maxTicksLimit: 11,// Limiting the number of ticks on the x-axis
                                            maxRotation: 0, // Prevents the labels from rotating
                                            minRotation: 0 // Ensures labels start horizontally
                                        }
                                    },
                                    y: {
                                        grid: {
                                            borderColor: '#4D4D4D',
                                            color: (context) => {
                                                // Only show a few dashed grey lines
                                                // e.g., draw every 2nd or 3rd line based on tick index
                                                return context.index % 4 === 0 ? '#808080' : 'transparent';
                                            },
                                            borderDash: [4, 4], // makes them dashed
                                            lineWidth: 1,
                                        }
                                    }
                                }
                            }}
                            height={"80px"}
                        />



                    )







                }
                else {

                    const xgraphData = props.data.data.map((ele) => {
                        return ele["time"] && moment(ele["time"]).locale('en').format("HH:mm");
                    });


                    console.log(props.selectedParamList)

                    // Filter duplicate timestamps and prepare Y-axis data
                    const filteredData = props.data.data.reduce((acc, current) => {
                        const found = acc.find(item => item.time === current.time);
                        if (!found) {
                            acc.push(current);
                        }
                        return acc;
                    }, []);

                    const ygraphData = filteredData.map((ele) => ele[graphParam.name]);

                    // Determine line color based on the label
                    let lineColor = "#FFFFFF"; // Default color
                    if (graphParam.label === "HR") {
                        lineColor = "#67DF52";
                    } else if (graphParam.label === "PR") {
                        lineColor = "#3ADAE5";
                    }
                    else if (graphParam.label === "SPO2") {
                        lineColor = "#3ADAE5";
                    }
                    else if (graphParam.label === "RR") {
                        lineColor = "#FCC331";
                    }

                    return (
                        <Line
                            className="line-graph-vital"
                            key={graphParam.name}
                            data={{
                                labels: xgraphData,
                                datasets: [{
                                    data: ygraphData,
                                    fill: false,
                                    borderColor: lineColor,
                                    borderWidth: 2,
                                    tension: 0,
                                    pointRadius: 1.5,
                                }],
                            }}
                            options={{
                                plugins: {
                                    tooltip: {
                                        enabled: true,
                                        position: 'nearest',
                                    },
                                    legend: {
                                        display: false,
                                    },
                                    title: {
                                        display: true,
                                        text: graphParam.label,
                                        align: 'start',
                                        color: lineColor, // Title color matches line color
                                        font: {
                                            size: 16,
                                            weight: 600,
                                        },
                                        padding: {
                                            bottom: 20,
                                        }
                                    },
                                },
                                scales: {
                                    x: {
                                        grid: {
                                            borderColor: '#4D4D4D',

                                        },

                                        ticks: {
                                            autoSkip: true,
                                            maxTicksLimit: 11,// Limiting the number of ticks on the x-axis
                                            maxRotation: 0, // Prevents the labels from rotating
                                            minRotation: 0 // Ensures labels start horizontally
                                        },
                                        
                                    },
                                    y: {
                                        grid: {
                                            borderColor: '#4D4D4D',
                                            color: (context) => {
                                              
                                                return context.index % 4 === 0 ? '#808080' : 'transparent';
                                            },
                                            borderDash: [4, 4], 
                                            lineWidth: 1,
                                        }
                                    }
                                }
                            }}
                            height={"80px"}
                        />
                    )

                }

            })}
        </div>
    );
}

export default TrendGraph;
